import bridgeMsg from "@/js_sdk/bridgeMsg.js";
import titleBarTheme from "@/js_sdk/titleBarTheme.js";

export const onNavigationBarButtonTap = (e) => {
  // const index = e.index;
  console.log(e);
  switch (e.btnType) {
    case "user":
      uni.navigateTo({
        url: "/pages/user/user",
      });
      break;
    case "cart":
      uni.navigateTo({
        url: "/pages/cart/cart",
      });
      break;
    default:
  }
  // if (index === 0) {
  // 	uni.navigateTo({
  // 		url: '/pages/user/user'
  // 	})
  // }
  // else if (index === 1) {
  //







  // uni.navigateTo({
  // 	url: '/pages/notice/notice'
  // })
  // }
};

export const navigationUrl = (url) => {
  if (url?.includes("http://") || url?.includes("https://")) {
    let type;
    if (
      (url?.includes("blurams.com") ||
      url?.includes("vimvp.cn")) &&
      !url?.includes("lcap")
    ) {
      type = "POST";
    } else {
      type = "GET";
    }
    bridgeMsg.openPage(url, type?.toLowerCase(), titleBarTheme.ThemeCommon());
    return;
  }
  uni.navigateTo({
    url: url,
  });
};

export const navBack = () => {
  const pages = getCurrentPages();
  if (pages[pages.length - 1]?.route?.indexOf("pages/index/index") > -1) {
    bridgeMsg.closePage();
    const systemInfo = uni.getSystemInfoSync();
    if (systemInfo?.osName === "ios") {
      hideNavBar();
    }
    return;
  }
  if (pages.length > 1) {
    uni.navigateBack({
      delta: 1,
    });
    return;
  }
  uni.redirectTo({
    url: "/pages/index/index",
  });
};

export const showNavBar = () => {
  console.log("...show");
  bridgeMsg.setTheme({ theme: "1" });
};

export const hideNavBar = () => {
  console.log("...hide");
  bridgeMsg.setTheme(titleBarTheme.ThemeCommon());
};

export const goToError = () => {
  uni.navigateTo({ url: `/pages/public/error?vTime=${new Date().getTime()}` });
}